import store from '../store/index'

const SystemJwtService = {
    getSystemJwtToken: async function() {
        return new Promise((resolve) => {
            let tokenStore = store.getters.getSystemJwtToken;

            if (!tokenStore || tokenStore.loginExpirado || tokenStore.token === null) {
                store.dispatch("authAppUser").then((resultado) => {
                    store.commit("setSystemJwtToken", resultado.token);

                    if (resultado.sucesso) {
                        resolve(resultado.token.token);
                    } else {
                        resolve(null);
                    }
                    
                });
            } else {
                resolve(tokenStore.token);
            }
        })
    }
}

export default SystemJwtService;